




































import Vue from 'vue'

export default Vue.extend({
  name: 'OfferActionBlock',

  props: {
    actionComplete: {
      type: Boolean,
      default: false,
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
    actionRepeatble: {
      type: Boolean,
      default: false,
    },
    actionStatic: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    actionNumber: {
      type: Number,
      default: null,
    },
    actionLink: {
      type: String,
      default: null,
    },
    actionText: {
      type: String,
      required: true,
    },
    actionSubText: {
      type: String,
      default: null,
    },
  },

  computed: {
    actionBlockClasses: function () {
      return {
        'step-disabled': this.actionDisabled,
        'step-complete': this.actionComplete,
        'step-static': !this.actionDisabled && this.actionStatic,
        'step-active': !this.actionDisabled && !this.actionStatic && !this.actionComplete,
      }
    },
  },

  methods: {
    handleActionLink: function () {
      if (!this.actionRepeatble && (this.actionDisabled || this.actionComplete)) return

      if (this.actionLink) {
        this.$router.push(this.actionLink)
      }

      this.$emit('offer-action-block-link-clicked')
    },
  },
})
